import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const TafelPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#FDF2E7',
      100: '#FCE5CE',
      200: '#F9CB9D',
      300: '#F5B16D',
      400: '#F2973C',
      500: '#EF7D0B',
      600: '#BF6409',
      700: '#8F4B07',
      800: '#603204',
      900: '#301902',
      950: '#180C01'
    }
  }
});
